import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";

import {
  getEventApprove,
  getEventDetailsById,
  getEventReject,
  getEventUpdate,
} from "../../api";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import { Toast } from "primereact/toast";
// import { EventDetailsSchema } from "../../schema";
import moment from "moment";
import { EventSchema } from "../../schema";
// import { useFormik } from "formik";

const initialValues = {
  // ProfileDetails
  image: null,
};

const EventDetails = ({ id }) => {
  const navigate = useNavigate();
  const { token } = useSelector((state) => state.profileReducer);
  const [serviceData, setServiceData] = useState(null);
  const toast = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [image1, setImage] = useState(null);
  const [previewImg, setPreviewImg] = useState(null);

  const getEventRequestManagement = async () => {
    setIsLoading(true);
    getEventDetailsById(id, token)
      .then((res) => {
        setServiceData(res?.data?.data[0]);
        setPreviewImg(res?.data?.data[0].image);
        setIsLoading(false);
      })
      .catch((err) => {});
  };

  const updateHandler = async (Userid) => {
    const formData = new FormData();

    formData.append(
      "userId",
      serviceData?.userId
        .split(",")
        .filter((ele) => ele !== `${Userid}`)
        .join()
    );
    await getEventUpdate(id, formData, token).then((res) => {
      getEventRequestManagement();
      // setImageChange(true)
    });
  };

  useEffect(() => {
    async function getAllAPI() {
      await getEventRequestManagement();
    }
    getAllAPI();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onEditHandler = () => {
    navigate(`/event-management/EditEvent?eventId=${id}`);
  };

  const { errors, handleSubmit, setFieldValue } = useFormik({
    initialValues,
    validationSchema: EventSchema(),
    onSubmit: () => onsaveimage(),
  });
  const approveEventHandler = async () => {
    setIsLoading(true);
    getEventApprove(id, token)
      .then((res) => {
        setIsLoading(false);
        toast.current.show({
          severity: "success",
          summary: `${res?.data?.message}`,
        });
        setTimeout(() => {
          navigate("/event-management");
        }, 3000);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.current.show({
          severity: "error",
          summary: `${err?.response?.data?.message}`,
        });
      });
  };

  const rejectEventHandler = async () => {
    setIsLoading(true);
    getEventReject(id, token)
      .then((res) => {
        setIsLoading(false);
        toast.current.show({
          severity: "success",
          summary: `${res?.data?.message}`,
        });
        setTimeout(() => {
          navigate("/event-management");
        }, 3000);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.current.show({
          severity: "error",
          summary: `${err?.response?.data?.message}`,
        });
      });
  };

  const handleImageUpload = (e, setImage) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
    }
    if (e.target.files.length) {
      const reader = new FileReader();
      reader.onload = () => {
        setPreviewImg(reader.result);
        setFieldValue("image", file);
      };
      reader.readAsDataURL(file);
    }
  };

  const onsaveimage = async () => {
    const formData = new FormData();
    if (image1) formData.append("image", image1);
    await getEventUpdate(
      id,
      formData,
      token
      // {
      //   userId: serviceData?.userId
      //     .split(",")
      //     .filter((ele) => ele !== Userid)
      //     .join(),
      //     image: image1
      // },
    )
      .then((res) => {
        setIsLoading(false);
        toast.current.show({
          severity: "success",
          summary: `${res?.data?.message}`,
        });
        setTimeout(() => {
          navigate("/event-management");
        }, 2000);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.current.show({
          severity: "error",
          summary: `${err?.response?.data?.message}`,
        });
      });
  };

  return (
    <>
      <Toast ref={toast} />
      {isLoading && (
        <div className="set-proper-line-in-all-page">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
      <div className="event-details-all-starting-part">
        <div className="userprofile-pics">
          <div className="d-flex align-items-center justify-content-between blocking-responsive">
            <div className="d-flex align-items-center">
              <svg
                width="32"
                height="24"
                onClick={() => {
                  navigate(-1);
                }}
                viewBox="0 0 32 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="cursor-pointer"
              >
                <path
                  d="M0.93934 10.9393C0.353553 11.5251 0.353553 12.4749 0.93934 13.0607L10.4853 22.6066C11.0711 23.1924 12.0208 23.1924 12.6066 22.6066C13.1924 22.0208 13.1924 21.0711 12.6066 20.4853L4.12132 12L12.6066 3.51472C13.1924 2.92893 13.1924 1.97919 12.6066 1.3934C12.0208 0.807611 11.0711 0.807611 10.4853 1.3934L0.93934 10.9393ZM2 13.5H32V10.5H2V13.5Z"
                  fill="black"
                />
              </svg>
              <h6 className="mb-0">Event Details</h6>
            </div>
            <div className="right-side-btn-add d-flex align-items-center event-details-btn-cls">
              {serviceData?.status === "Requested" && (
                <button
                  type="button"
                  className="btn btn-primary approve-success-outline me-3"
                  onClick={() => approveEventHandler()}
                >
                  Approve
                </button>
              )}
              {(serviceData?.status === "Requested" ||
                serviceData?.status === "On Going") && (
                <button
                  type="button"
                  className="btn btn-primary reject-outline me-3"
                  onClick={() => rejectEventHandler()}
                >
                  Reject
                </button>
              )}
              <button
                type="button"
                className="btn btn-primary pink-outline"
                onClick={() => onEditHandler()}
              >
                Edit
              </button>
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="event-details-profile-user-img body-part-area-start-profile">
            <div className="row">
              <div className="col-lg-3">
                <div className="eventdetails-img-cls">
                  {previewImg && serviceData && (
                    <div className="text-centersall">
                      <img
                        src={
                          previewImg
                            ? previewImg
                            : require("../../assets/defaultImg.png")
                        }
                        alt="Preview1"
                      />

                      <div className="change-photo-btn mt-4">
                        <span className="required">
                          {" "}
                          Please Upload the Image into (300w X 280h) Dimension
                        </span>
                        <input
                          type="file"
                          name="image"
                          placeholder="Change Event Photo"
                          accept="image/png, image/jpeg, image/jpg"
                          className="btn btn-primary change-event-photo w-100 set-to-auto-height"
                          onChange={(e) => handleImageUpload(e, setImage)}
                        />
                        {errors.image ? (
                          <p className="form-error">{errors.image}</p>
                        ) : null}
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="col-lg-9 styling-portion-add">
                <div className="second-sideuser">
                  <div className="first-portion mb-3">
                    <div className="title-name">
                      <label>Name</label>
                      <div className="subtitle-names">
                        <h6 className="mb-0">
                          {serviceData?.name ? serviceData?.name : "-"}
                        </h6>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12 col-6">
                    <div className="first-portion mb-3">
                      <div className="title-name">
                        <label>Description</label>
                        <div className="subtitle-names">
                          <h6 className="mb-0">{serviceData?.description}</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-4 col-6">
                      <div className="first-portion mb-3">
                        <div className="title-name">
                          <label>Date</label>
                          <div className="subtitle-names">
                            <h6 className="mb-0">
                              {serviceData?.date
                                ? moment(serviceData?.date).format("DD-MM-YYYY")
                                : "-"}
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 col-6">
                      <div className="first-portion mb-3">
                        <div className="title-name">
                          <label>Time</label>
                          <div className="subtitle-names">
                            <h6 className="mb-0">{serviceData?.time}</h6>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 col-6">
                      <div className="first-portion mb-3">
                        <div className="title-name">
                          <label>Location</label>
                          <div className="subtitle-names">
                            <h6 className="mb-0">{serviceData?.location}</h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />

            <div className="main-memebr-part-cls-all">
              <div className="memeber-details-all-set">
                <label>Members</label>
              </div>
              <div className="memeber-all-part-cls">
                <div className="row mt-4">
                  {serviceData?.userResult?.map((ele, index) => {
                    return (
                      <div
                        key={index}
                        className="col-lg-3 position-relative col-6"
                      >
                        <button
                          type="button"
                          className="btn btn-primary closing-close-cls w-100"
                        >
                          {ele?.first_name + " " + ele?.last_name}
                        </button>
                        <span
                          className="close-ics-all-done"
                          onClick={() => updateHandler(ele?.id)}
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M18 6L6 18M18 18L6 6.00001"
                              stroke="#111111"
                              strokeWidth="2"
                              strokeLinecap="round"
                            />
                          </svg>
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            <hr />
            <div className="right-sidebtn-add text-end">
              <div className="d-flex align-items-center justify-content-end">
                <button
                  type="button"
                  className="btn btn-primary outline-btn-cls me-2"
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary filled-btn-cls"
                  // onClick={() => onsaveimage(id)}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default EventDetails;
